export async function errorAPI(data) {
  if(data === 500) return data
  if(data.status !== 200 && data.status !== 301 && data.status !== 302) return data.status
  
  const json = await data.json()
  return json
}
